import React from 'react';
import { ModalClose } from '../../atoms/modalClose';
import { Button } from "../../atoms/button";
import './../../../resources_membership_hotel/css/hotel/membership_crawl_modal.css';

export const DescriptionHomeFlContainer = (props) => {
    const {
        state,
        onClickCloseDescriptionHomeFlWindow
    } = props;

    let popupFlg = state.descHomeFlPopup;

    return (
        <div className={popupFlg ? 'popupIsShow' : 'popup'} id='js-popup'>
            <div className='popupInner'>
                <div className="popupHeader">
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClickCloseDescriptionHomeFlWindow()} />
                    <h4 className='popupInnerText' >ホームフローティング</h4>
                </div>
                <div className="popupBodyWrapper">
                    <div className="messageClass" >
                        <div className="popupText">ホームフローティング（ホームFL）とは、①サンクチュアリコート会員権でご契約施設のご利用、かつ②ご利用日から１ヵ月前まで（フローティング期間）の空室をご利用の場合に、ご利用日の1ヶ月前の同日から先着順で20泊タイプは月10泊、10泊タイプは月5泊まで占有日（権利）を消化することなくご利用になれます。※メンバー以外（ゲスト利用）の方がレッドの日にホームフローティング（占有日を消化しない利用）で宿泊される場合はゲスト料金となりますのでご注意ください。</div>
                    </div>
                </div>
                <div className="buttonArea2 buttonAreaSticky" >
                    <Button className="button" onClick={() => onClickCloseDescriptionHomeFlWindow()} buttonClassName="buttonText" buttonText="OK" />
                </div>
            </div>
            <div className='blackBackground' id='js-black-bg'></div>
        </div >
    );
};
